import { readAndCompressImage } from "browser-image-resizer";

export function getInitials(firstName?: string, lastName?: string) {
  return `${firstName?.[0] || ""}${lastName?.[0] || ""}`;
}

export function formatDate(date?: string) {
  return date?.slice(0, 10) || "";
}

export function formatDateTime(date?: string) {
  return date?.split(".")[0].replace("T", " ") || "";
}

export function capitalizeFirstLetter(word?: string): string | undefined {
  if (!word) return undefined;
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

export const convertSnakeCaseToSpace = (str?: string) =>
  str?.replace(/_/g, " ");

export const snakeCaseToCapitalized = (str?: string) =>
  capitalizeFirstLetter(convertSnakeCaseToSpace(str));

// TODO: Use built in Objects.groupBy...
export function groupBy<T>(elements: T[], key: keyof T) {
  return elements.reduce(
    (agg, element) => {
      const value = element[key] as string;
      (agg[value] = agg[value] || []).push(element);
      return agg;
    },
    {} as Record<string, T[]>,
  );
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) {
    return "0 Bytes";
  }
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / Math.pow(1024, i);
  return `${parseFloat(value.toFixed(2))} ${sizes[i]}`;
}

export function hasStringKey<K extends string>(
  k: K,
  o: unknown,
): o is { [_ in K]: string } {
  return typeof o === "object" && o !== null && k in o;
}

export async function resizeImageFile(
  file: File,
  width: number,
  height: number,
): Promise<File> {
  const blob = await readAndCompressImage(file, {
    quality: 1,
    maxWidth: width,
    maxHeight: height,
  });
  return new File([blob], file.name, { type: file.type });
}
